module.exports = __webpack_public_path__ + "img/shop.da67d1b4.png";